import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  contentRoot: {
    alignItems: "stretch",
    flexDirection: "column",
    paddingLeft: 90,
    paddingRight: 90,
    display: "grid",
    gap: theme.spacing.space32,
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    /**
     * webOS 22 only (`not (aspect-ratio)` = Chromium <=87; aspect-ratio shipped in 88):
     * give a definite height and pin the row to 1fr so all 3 columns' height:100% resolve.
     */
    "@supports not (aspect-ratio: 1 / 1)": {
      height: "100%",
      minHeight: 0,
      gridTemplateRows: "minmax(0, 1fr)",
    },
  },
  serviceCard: {
    aspectRatio: "2 / 1.2",
  },
  featuredCard: {
    height: "100% !important",
  },
  consoleContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space32,
    width: "100%",
    height: "100%",
  },
  consoleContentLeft: {
    height: "100%",
    alignItems: "stretch",
  },
  consoleCardDesktop: {
    height: "100%",
    justifyContent: "center",
    flex: 1,
    minHeight: 0,
  },
  activityCard: {
    padding: `0px ${theme.spacing.space24}px !important`,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing.space20,
  },
  title: {
    paddingBottom: theme.spacing.space24,
  },
  description: {
    textAlign: "center",
  },
}));
